import React, { useState } from 'react';
import { supportService } from '../services/api';

const SUPPORT_WHATSAPP = '22374146816';
const SUPPORT_EMAIL = 'it43694@gmail.com';

const openWhatsApp = () => {
  window.open(`https://wa.me/${SUPPORT_WHATSAPP}`, '_blank', 'noopener,noreferrer');
};

const openEmailFallback = (subject, body) => {
  window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

const buildSupportPayload = ({ support_type, sujet, message, contexte }) => ({
  support_type,
  sujet,
  message,
  contexte,
});

const sendSupportRequest = async (payload, fallbackSubject, fallbackBody) => {
  if (!navigator.onLine) {
    openEmailFallback(fallbackSubject, fallbackBody);
    return null;
  }

  try {
    return await supportService.sendSupportRequest(payload);
  } catch (error) {
    openEmailFallback(fallbackSubject, fallbackBody);
    throw error;
  }
};

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const feedbackSuccess = () => setStatusMessage('Votre demande a bien été envoyée. Nous vous répondrons bientôt.');

  const handleEmailRequest = async () => {
    const subject = 'Besoin d’assistance AgroShop';
    const body = 'Bonjour AgroShop,\n\nJe souhaite obtenir de l’assistance pour ma commande ou un conseil technique.\n\nMerci.';
    const payload = buildSupportPayload({
      support_type: 'autre',
      sujet: subject,
      message: body,
      contexte: window.location.href,
    });

    setStatusMessage('');
    setErrorMessage('');
    setSending(true);

    try {
      await sendSupportRequest(payload, subject, body);
      feedbackSuccess();
    } catch (error) {
      setErrorMessage(error.message || 'Impossible d’envoyer la demande. Essayez via e-mail.');
    } finally {
      setSending(false);
    }
  };

  const handleAgronomeRequest = async () => {
    const subject = 'Demande de conseil agronome AgroShop';
    const body = 'Bonjour AgroShop,\n\nJe souhaite recevoir un conseil agronome pour mes cultures.\n\nMerci de me contacter avec une recommandation adaptée.';
    const payload = buildSupportPayload({
      support_type: 'conseil',
      sujet: subject,
      message: body,
      contexte: window.location.href,
    });

    setStatusMessage('');
    setErrorMessage('');
    setSending(true);

    try {
      await sendSupportRequest(payload, subject, body);
      feedbackSuccess();
    } catch (error) {
      setErrorMessage(error.message || 'Impossible d’envoyer la demande. Essayez via e-mail.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="ag-chat-widget">
      <button type="button" className="ag-chat-button" onClick={() => setOpen((prev) => !prev)}>
        {open ? 'Fermer le chat' : 'Chat Support'}
      </button>
      {open && (
        <div className="ag-chat-panel">
          <p>Support en ligne rapide pour vos commandes, retours et conseils techniques.</p>
          <button type="button" className="ag-btn ag-btn--primary" onClick={openWhatsApp}>
            Chat WhatsApp
          </button>
          <button type="button" className="ag-btn ag-btn-secondary" onClick={handleEmailRequest} disabled={sending}>
            {sending ? 'Envoi en cours…' : 'Envoyer un e-mail'}
          </button>
          <button type="button" className="ag-btn" onClick={handleAgronomeRequest} disabled={sending}>
            {sending ? 'Envoi en cours…' : 'Conseil agronome'}
          </button>
          {statusMessage && (
            <div className="ag-alert ag-alert-success" style={{ marginTop: '12px' }}>
              {statusMessage}
            </div>
          )}
          {errorMessage && (
            <div className="ag-alert ag-alert-error" style={{ marginTop: '12px' }}>
              {errorMessage}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
